import _classCallCheck from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';

var Index = /*#__PURE__*/function (_Vue) {
  _inherits(Index, _Vue);

  var _super = _createSuper(Index);

  function Index() {
    var _this;

    _classCallCheck(this, Index);

    _this = _super.apply(this, arguments);
    _this.seconds = 59;
    _this.cur = 0;
    _this.running = false;
    return _this;
  }

  _createClass(Index, [{
    key: "startCountDown",
    value: function startCountDown() {
      var _this2 = this;

      if (this.running) return;
      this.running = true;
      this.cur = this.seconds;

      var countFn = function countFn() {
        if (_this2.cur === 0) {
          _this2.reset();
        } else {
          _this2.cur--;
          _this2.timer = window.setTimeout(countFn, 1000);
        }
      };

      countFn();
    } // 恢复正常初始状态

  }, {
    key: "ready",
    value: function ready() {
      this.running = false;
    } // 强制重置

  }, {
    key: "reset",
    value: function reset() {
      clearTimeout(this.timer);
      this.ready();
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this3 = this;

      if (this.running) return;
      this.task(function () {
        _this3.startCountDown();
      });
    }
  }]);

  return Index;
}(Vue);

__decorate([Prop({
  default: false
})], Index.prototype, "disabled", void 0);

__decorate([Prop({
  required: true
})], Index.prototype, "task", void 0);

Index = __decorate([Component({
  name: 'ButtonVerificationCode'
})], Index);
export default Index;